import { privateInstance, mapUrl } from "../configs";

export const preparationSlipTemplateApi = {
  //Slips
  async getPreparationSlipTemplates(params) {
    let url = "/inventory/api/preparationslip/template/";

    if (params) {
      if (params.store) url += `?store=${params.store}/`;
    }

    const res = await privateInstance.get(url);
    return res.data;
  },
  async postPreparationSlipTemplate(slip) {
    let url = "/inventory/api/preparationslip/template/";
    const res = await privateInstance.post(url, slip);
    return res.data;
  },
  async retrievePreparationSlipTemplate(id) {
    let url = `/inventory/api/preparationslip/template/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchPreparationSlipTemplate(id, slip) {
    let url = `/inventory/api/preparationslip/template/${id}/`;
    const res = await privateInstance.patch(url, slip);
    return res.data;
  },
  async deletePreparationSlipTemplate(id, slip) {
    let url = `/inventory/api/preparationslip/template/${id}/`;
    const data = {
      ...slip,
      is_deleted: !slip.is_deleted
    };
    const res = await privateInstance.patch(url, data);
    return res.data;
  },
  //Products
  async getPreparationSlipTemplateProducts(params) {
    let url = "/inventory/api/preparationslip/template/product?";

    if (params) {
      if (params.store) url += `store=${params.store}&`;
    }

    const res = await privateInstance.get(mapUrl(url));
    return res.data;
  },
  async postPreparationSlipTemplateProduct(slip) {
    let url = "/inventory/api/preparationslip/template/product/";
    const res = await privateInstance.post(url, slip);
    return res.data;
  },
  async retrievePreparationSlipTemplateProduct(id) {
    let url = `/inventory/api/preparationslip/template/product/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchPreparationSlipTemplateProduct(id, slip) {
    let url = `/inventory/api/preparationslip/template/product/${id}/`;
    const res = await privateInstance.patch(url, slip);
    return res.data;
  },
  async deletePreparationSlipTemplateProduct(id) {
    let url = `/inventory/api/preparationslip/template/product/${id}/`;
    const res = await privateInstance.delete(url);
    return res.data;
  },
  async getDefaultDailyPreparationSlip() {
    let url = `/inventory/api/preparationslip/defaultdaily/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async postDefaultDailyPreparationSlip(data) {
    let url = `/inventory/api/preparationslip/defaultdaily/`;
    const res = await privateInstance.post(url, data);
    return res.data;
  },
  async retrieveDefaultDailyPreparationSlip(id) {
    let url = `/inventory/api/preparationslip/defaultdaily/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async updateDefaultDailyPreparationSlip(id, data) {
    let url = `/inventory/api/preparationslip/defaultdaily/${id}/`;
    const res = await privateInstance.put(url, data);
    return res.data;
  }
};
